import React from 'react'
import PropTypes from 'prop-types'
import HoverWrapper from '../HoverWrapper'
import HintIcon from '../Icons/HintIcon'
import { theme } from '../../Assets/Styles/theme'

import { StarRatingStyled } from './style'

const buildStarFilling = (score, max, step) => {
  return Array.apply(null, Array(max)).map((v, index) => {
    const idx = index + 1
    const scr = parseFloat(score) || 0

    if (idx <= scr) return 100
    if (idx - step <= scr) return step * 100
    return 0
  })
}

const Star = ({ index, fill, color }) => (
  <svg viewBox="0 0 15 15">
    <defs>
      <linearGradient
        id={`star-gradient-${index}`}
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop offset={`${fill}%`} style={{ stopColor: color }} />
        <stop
          offset={`${fill}%`}
          style={{ stopColor: theme.colors.athensGray2 }}
        />
      </linearGradient>
    </defs>
    <polygon
      fill={`url(#star-gradient-${index})`}
      points="7.5 12.4376941 2.86474508 15 3.75 9.57294902 -6.38933351e-14 5.72949017 5.18237254 4.9376941 7.5 0 9.81762746 4.9376941 15 5.72949017 11.25 9.57294902 12.1352549 15"
    />
  </svg>
)

Star.propType = {
  index: PropTypes.number.isRequired,
  fill: PropTypes.number.isRequired,
}

const MissionStarRatingWithHint = ({
  uniqueId,
  ratingInfo,
  max = 5,
  step = 0.5,
}) => {
  if (!ratingInfo) {
    return ' - '
  }

  const {
    rating,
    conversionRateSubRating,
    conversionRateMean,
    scanRateSubRating,
    scanRateMean,
    checkoutFlyerRateSubRating,
    checkoutFlyerRateMean,
    comparisonScope,
  } = ratingInfo

  const starFilling = buildStarFilling(rating, max, step)
  const starFillingConversionRate = buildStarFilling(
    conversionRateSubRating,
    max,
    step,
  )
  const starFillingScanRate = buildStarFilling(scanRateSubRating, max, step)
  const starFillingFlyerDistributionRate = buildStarFilling(
    checkoutFlyerRateSubRating,
    max,
    step,
  )

  return (
    <HoverWrapper
      style={{ maxWidth: 450 }}
      hoverText={
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div>
              <strong>Conversion Rate</strong> (45% weight)
              <strong>:</strong>{' '}
            </div>
            <div style={{ marginBottom: 4, marginLeft: 6 }}>
              <StarRatingStyled key={`${uniqueId}-conversionRate`}>
                {starFillingConversionRate.map((filling, index) => {
                  const key = `${uniqueId}-conversionRate-${index}`

                  return (
                    <Star
                      index={key}
                      key={key}
                      fill={filling}
                      color={theme.colors.amaranth2}
                    />
                  )
                })}
              </StarRatingStyled>
            </div>
          </div>
          <div>Scope Avg: {conversionRateMean}%</div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 4,
            }}
          >
            <div>
              <strong>Scan Rate</strong> (45% weight)
              <strong>:</strong>{' '}
            </div>
            <div style={{ marginBottom: 4, marginLeft: 6 }}>
              <StarRatingStyled key={`${uniqueId}-scanRate`}>
                {starFillingScanRate.map((filling, index) => {
                  const key = `${uniqueId}-scanRate-${index}`
                  return (
                    <Star
                      index={key}
                      key={key}
                      fill={filling}
                      color={theme.colors.amaranth2}
                    />
                  )
                })}
              </StarRatingStyled>
            </div>
          </div>
          <div>Scope Avg: {scanRateMean}%</div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 4,
            }}
          >
            <div>
              <strong>Flyer Distribution Rate</strong> (10% weight)
              <strong>:</strong>{' '}
            </div>
            <div style={{ marginBottom: 4, marginLeft: 6 }}>
              <StarRatingStyled key={`${uniqueId}-flyerDistributionRate`}>
                {starFillingFlyerDistributionRate.map((filling, index) => {
                  const key = `${uniqueId}-flyerDistributionRate-${index}`

                  return (
                    <Star
                      index={key}
                      key={key}
                      fill={filling}
                      color={theme.colors.amaranth2}
                    />
                  )
                })}
              </StarRatingStyled>
            </div>
          </div>
          <div>Scope Avg: {checkoutFlyerRateMean}%</div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 4,
            }}
          >
            <div>
              <strong>Comparison Scope Used:</strong> {comparisonScope}
            </div>
          </div>
        </div>
      }
      uniqueId="rating-global-planing"
      element={
        <div style={{ display: 'flex' }}>
          <StarRatingStyled key={uniqueId}>
            {starFilling.map((filling, index) => {
              const key = `${uniqueId}-${index}`
              return (
                <Star
                  index={key}
                  key={key}
                  fill={filling}
                  color={theme.colors.amaranth2}
                />
              )
            })}
          </StarRatingStyled>{' '}
          <HintIcon style={{ margin: '2px 4px 0px 6px' }} />
        </div>
      }
    />
  )
}

export { MissionStarRatingWithHint }
